import axios from 'axios'

type UnauthorizedHandler = () => void | Promise<void>

let unauthorizedHandler: UnauthorizedHandler | null = null
let isHandlingUnauthorized = false

export const setUnauthorizedHandler = (handler: UnauthorizedHandler): void => {
  unauthorizedHandler = handler
}

export const client = axios.create({
  baseURL: process.env.REACT_APP_BACKEND,
  responseType: 'json'
})

client.interceptors.response.use(
  response => response,
  async error => {
    const isLoginRequest = error?.config?.url?.startsWith('/user/login')
    if (error?.response?.status === 401 && !isLoginRequest && !isHandlingUnauthorized) {
      isHandlingUnauthorized = true
      sessionStorage.setItem('cocap:session-expired', '1')

      try {
        if (unauthorizedHandler) {
          await unauthorizedHandler()
        } else {
          localStorage.removeItem('persist:root')
        }
      } finally {
        window.location.replace('/login')
      }
    }
    return Promise.reject(error)
  }
)
